// @flow
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import cx from 'classnames';
import { Helmet } from 'react-helmet';
import ScrollToTop from 'components/common/ScrollToTop';
import MarkdownRender from 'components/common/MarkdownRender/MarkdownRender';
import policyData from '../policyData';
import './PolicyViewer.scss';

type Props = {
  mode: string,
};

class PolicyViewer extends Component<Props> {
  render() {
    const { mode } = this.props;
    const titles = {
      privacy: '개인정보처리방침',
      terms: '이용약관',
      marketing: '마케팅 정보 수신 동의',
    };
    const title = titles[mode] || titles.privacy;
    return (
      <div className="PolicyViewer">
        <Helmet>
          <title>{`${title} | 캐시바이`}</title>
          <meta
            name="description"
            content={`캐시바이 서비스의 ${title} 페이지 입니다.`}
          />
          <meta name="robots" content="noindex" />
        </Helmet>
        <div className="links">
          <Link to="/policy/privacy" className={cx({ active: mode === 'privacy' })}>
            개인정보처리방침
          </Link>
          <Link to="/policy/terms" className={cx({ active: mode === 'terms' })}>
            이용약관
          </Link>
          <Link to="/policy/marketing" className={cx({ active: mode === 'marketing' })}>
            마케팅 정보 수신 동의
          </Link>
        </div>
        <MarkdownRender body={policyData[mode]} />
      </div>
    );
  }
}

export default PolicyViewer;



// WEBPACK FOOTER //
// ./src/components/policy/PolicyViewer/PolicyViewer.js